import React from 'react';
import { IOpenShiftsSidebarPanel } from './interfaces';
import { ContentPanel } from '@components/ContentPanel';
import { Button, Typography } from '@mui/material';

export const OpenShiftsSidebarPanel: React.FC<
  IOpenShiftsSidebarPanel
> = ({}): JSX.Element => {
  return (
    <ContentPanel borderRadius="none" title="Open diensten">
      <Typography variant="body2" sx={{ mb: 1 }}>
        Nog <strong>5</strong> diensten onbezet
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Zonder vrijwilligers kunnen sommige activiteiten niet doorgaan. Jouw
        hulp maakt hier echt het verschil.
      </Typography>

      <Button variant="contained" fullWidth>
        Bekijk open diensten
      </Button>
    </ContentPanel>
  );
};
